
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type FilterState = {
  filterString: string;
  filterCount: number;
  transactionListFilterPayload?: any;
  filterList: {HeaderColumn: string, Name: string}[];
};

type Filters = {
  [screen: string]: FilterState;
};

const initialFilterState: FilterState = {
  filterString: "",
  filterCount:0,
  transactionListFilterPayload: null,
  filterList: [{ HeaderColumn: '', Name: '' }],
};

const initialState: Filters = {};

export const advFilterSlice = createSlice({
  name: "advFilter",
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{
        screen: string;
        filterString: string;
        filterCount:number,
        transactionListFilterPayload: any;
        filterList: any;
      }>
    ) => {
      const { screen, filterString, filterCount, transactionListFilterPayload, filterList } = action.payload;

      state[screen] = {
        filterString,
        filterCount,
        transactionListFilterPayload,
        filterList
      };
    },

    resetFilter: (
      state,
      action: PayloadAction<{ screen: string }>
    ) => {
      const { screen } = action.payload;

      state[screen] = initialFilterState;
    },
    resetAllFilters: () => {
      return {};
    }
  }
});

export const { setFilter, resetFilter, resetAllFilters } = advFilterSlice.actions;

export default advFilterSlice.reducer;